











import Vue from "vue"
import { Component, Prop } from "vue-property-decorator"
import { palette } from "@/utils/palette";

/**
 * Progress bar that animates its completion on mount
 *
 * Pass it a fraction (progressCount & completeCount) or a percentage (completeCount)
 * to display progress.
 */
@Component<AnimatedProgressBar>({
    computed: {
        progressBarStyles() {
            return {
                width: `${this.progressBarWidth}%`,
                backgroundColor: this.barColour
            }
        }
    }
})
export default class AnimatedProgressBar extends Vue {
    @Prop({ type: Number, required: true })
    public progressCount!: number // Numerator of progress fraction
    @Prop({ type: Number, required: true })
    public completeCount!: number // Denominator of progress fraction

    @Prop({ type: String, default: palette.purple })
    public progressColour!: string // Colour of bar when it's not complete
    @Prop({ type: String, default: palette.successGreen })
    public completeColour!: string // Colour of bar when it's full

    public minPercent = 0
    public maxPercent = 100

    public beforeMount() {
        this.checkForCorrectProgressValues()
    }

    /**
     * Based on progress & completed count or percentage count, returns a
     * percentage number to use for CSS sizing & to check if completed.
     */
    public get progressBarWidth() : number {
        let percentage = (this.progressCount / this.completeCount) * 100

        if (percentage < this.minPercent) {
            percentage = this.minPercent
        } else if (percentage > this.maxPercent) {
            percentage = this.maxPercent
        }

        return percentage
    }

    public get fullBar() : boolean {
        return this.progressBarWidth === this.maxPercent
    }

    public get barColour() : string {
        return !this.fullBar ? this.progressColour : this.completeColour
    }

    /**
     * Checks if there is either a percentage value or both values for
     * the progress fraction.
     */
    private checkForCorrectProgressValues() {
        if (isNaN(this.progressCount) || isNaN(this.completeCount)) {
            throw new Error('Please provide both progress and complete values.')
        }
    }
}
